export default __webpack_public_path__ + "assets/cdpi-niteroi-component.840f0922.svg";